import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {
  latLng,
  MapOptions,
  tileLayer,
  MarkerClusterGroup,
  Map,
  Marker,
  icon,
} from "leaflet";
import { WidgetService } from '../service/widget.service';
import { Observable } from 'rxjs';

export interface CoordinatePackage {
  latitude: number | null;
  longitude: number | null;
  location: string | null;
  extra: number | null;
}

@Component({
  selector: 'app-template-map-advance',
  templateUrl: './template-map-advance.component.html',
  styleUrls: ['./template-map-advance.component.css']
})
export class TemplateMapAdvanceComponent implements OnInit {

  constructor(private widgetService: WidgetService) { }

  @Input() location_object: any;
  @Input() height_value!: string;
  @Input() zoom!: number;

  map!: Map;
  mapOptions!: MapOptions;
  layersControl!: any;
  marker = new Marker([0, 0]);

  gpsAddressObs!: Observable<any>;

  panelOpenState = false;

  level_country!: string | null;
  level_1!: string | null;
  level_2!: string | null;
  level_3!: string | null;
  level_4!: string | null;

  is_disabled = false;

  ngOnInit(): void {
    this.initializeMapOptions();
    this.fnUpdateLevels(this.location_object.address);

    // this.level_country = null;
    // this.level_1 = null;
    // this.level_2 = null;
    // this.level_3 = null;
    // this.level_4 = null;

  }

  onMapReady(_map: Map) {
    this.map = _map;
    this.fnAddMarker(
      this.location_object.location_lat.toFixed(6),
      this.location_object.location_lon.toFixed(6),
      this.location_object.address);

  }

  onMapClick($event: any) {
    this.marker.setLatLng($event["latlng"]);
    this.location_object.location_lat = $event["latlng"]["lat"].toFixed(6);
    this.location_object.location_lon = $event["latlng"]["lng"].toFixed(6);
    this.fnGetAddress();
  }

  onChangeLatLon() {
    this.fnGetAddress(true);
  }

  onChangeLvl() {
    this.location_object.address =
      (this.level_4 ? (this.level_4 + ', ') : '') +
      (this.level_3 ? (this.level_3 + ', ') : '') +
      (this.level_2 ? (this.level_2 + ', ') : '') +
      (this.level_1 ? (this.level_1 + ', ') : '') +
      this.level_country;
  }


  private fnGetAddress(add_markers = false) {
    this.gpsAddressObs = this.widgetService.getAddress(this.location_object.location_lat, this.location_object.location_lon);
    this.gpsAddressObs.subscribe(
      (_resp_address: any) => {

        this.is_disabled = !_resp_address.success;

        const _address = _resp_address.data.address;

        this.location_object.address = _address;
        this.level_4 = _resp_address.data.administrative_area_level_4;
        this.level_3 = _resp_address.data.administrative_area_level_3;
        this.level_2 = _resp_address.data.administrative_area_level_2;
        this.level_1 = _resp_address.data.administrative_area_level_1;
        this.level_country = _resp_address.data.country;

        if (add_markers) {
          this.fnAddMarker(
            this.location_object.location_lat,
            this.location_object.location_lon,
            _address
          );
        }

      }
    )
  }



  private fnUpdateLevels(address: string) {
    this.level_4 = '';
    this.level_3 = '';
    this.level_2 = '';
    this.level_1 = '';
    this.level_country = '';

    const lvl_list = address.split(', ');
    const lvl_length = lvl_list.length;

    lvl_list.map(
      (_lvl: string, index) => {

        if (index + 1 == lvl_length - 4) {
          this.level_4 = _lvl;
        } else if (index + 1 == lvl_length - 3) {
          this.level_3 = _lvl;
        } else if (index + 1 == lvl_length - 2) {
          this.level_2 = _lvl;
        } else if (index + 1 == lvl_length - 1) {
          this.level_1 = _lvl;
        } else if (index + 1 == lvl_length) {
          this.level_country = _lvl;
        }
      }
    );
  }




  private initializeMapOptions() {
    this.mapOptions = {
      layers: [
        tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          maxZoom: 18,
          minZoom: 1,
          attribution: "Map data © OpenStreetMap contributors",
        }),
      ],

      center: latLng(0, 0),
    };
    this.layersControl = {
      baseLayers: {
        Topological: tileLayer(
          "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
          {
            maxZoom: 18,
            minZoom: 1,
            attribution: "Map data © OpenStreetMap contributors",
          }
        ),
        Imagery: tileLayer(
          "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
          {
            maxZoom: 18,
            minZoom: 1,
            attribution: "Map data © OpenStreetMap contributors",
          }
        ),
        Outdoors: tileLayer(
          "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
          {
            maxZoom: 18,
            minZoom: 1,
            attribution: "Map data © OpenStreetMap contributors",
          }
        ),
        None: tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          maxZoom: 18,
          minZoom: 1,
          attribution: "Map data © OpenStreetMap contributors",
        }),
      },
    };
  }

  private fnAddMarker(_latitude: any, _longitude: any, _location: any) {
    this.marker.setIcon(
      icon({
        iconSize: [25, 41],
        iconAnchor: [13, 41],
        iconUrl: "assets/images/leaflet/marker-icon.png",
        shadowUrl: "assets/images/leaflet/marker-shadow.png",
      })
    );
    const _lat_s = ("<br/> latitude: " + _latitude) as string;
    const _lon_s = ("<br/> longitude: " + _longitude) as string;
    const _message = _location + _lat_s + _lon_s;
    this.marker.setLatLng([_latitude, _longitude]);
    this.marker.bindPopup(_message).openPopup();
    this.marker.addTo(this.map);
    this.fnSetFitBounds([{
      latitude: _latitude,
      longitude: _longitude
    }]);
    if (this.zoom) {
      this.map.setZoom(this.zoom);
    }
  }

  private fnSetFitBounds(coordinate_list: any[]) {

    const _lat_min = Math.min.apply(
      null,
      coordinate_list.map((x) => x.latitude)
    );
    const _lat_max = Math.max.apply(
      null,
      coordinate_list.map((x) => x.latitude)
    );
    const _lon_min = Math.min.apply(
      null,
      coordinate_list.map((x) => x.longitude)
    );
    const _lon_max = Math.max.apply(
      null,
      coordinate_list.map((x) => x.longitude)
    );
    if (this.map)
      this.map.fitBounds([
        [_lat_min, _lon_min],
        [_lat_max, _lon_max],
      ]);
  }



  private isNumber(value: string | number): boolean {
    return ((value != null) &&
      (value !== '') &&
      !isNaN(Number(
        value.toString().replace('-', '')
      )));
  }
}
